// import React from 'react';
import { useSelector } from 'react-redux';
import usePermissions from '../hooks/usePermissions';
import { isRunUnitTest } from '../redux/TestHelper/TestProvider/CheckRunTest';
import { getNamespace } from '../utils/storage';
const noAccess = [
    {
        id: 1,
        name: 'no_access',
        mainAccess: [1, 2, 5, 6, 7],
        patientAccess: [5, 6],
        settingAccess: []
    }
];
const mockMainAccess = [1, 2, 3, 4, 5, 6, 7];
const mockPatientAccess = [1, 2, 3, 4, 5, 6];
const mockSettingAccess = [1, 3, 4];
const useCheckAccess = () => {
    const { permissions } = usePermissions();
    const namespace = getNamespace();
    const userAccess = useSelector(
        (state) => state.user.userInfo?.namespaces?.find((item) => item.id === namespace)?.access
    );
    const userPermission = userAccess?.permissions;

    const roles =
        userPermission &&
        Object.keys(userPermission)?.filter(
            (key) =>
                !key.startsWith('delegate_') && (userAccess?.is_owner ? key : userPermission[key])
        );

    const findPermission = roles?.length
        ? permissions.filter((permission) => roles.find((role) => permission.name === role))
        : noAccess;
    const concatAccess = findPermission.reduce(
        (c, { mainAccess, patientAccess, settingAccess }) => {
            c['keys'] = c['keys'] || { mainAccess: [], patientAccess: [], settingAccess: [] };
            c['keys'].mainAccess = c['keys'].mainAccess.concat(mainAccess);
            c['keys'].patientAccess = c['keys'].patientAccess.concat(patientAccess);
            c['keys'].settingAccess = c['keys'].settingAccess.concat(settingAccess);

            return c;
        },
        {}
    );
    const mainAccess = !isRunUnitTest ? [...new Set(concatAccess.keys.mainAccess)] : mockMainAccess;
    const patientAccess = !isRunUnitTest
        ? [...new Set(concatAccess.keys.patientAccess)]
        : mockPatientAccess;
    const settingAccess = !isRunUnitTest
        ? [...new Set(concatAccess.keys.settingAccess)]
        : mockSettingAccess;

    const notEditDemographic = !isRunUnitTest
        ? !userAccess?.is_owner && !userPermission?.write_demographic
        : false;
    const notEditClinical = !isRunUnitTest
        ? !userAccess?.is_owner && !userPermission?.write_clinical
        : false;

    return {
        mainAccess,
        patientAccess,
        settingAccess,
        userAccess,
        notEditDemographic,
        notEditClinical
    };
};

export default useCheckAccess;
